import { useEffect, useState } from "react";
import AlpacaForm from "@components/AlpacaForm";

const RequisitionForm = ({ formSchema: _formSchema }) => {
    const [formSchema, setFormSchema] = useState({});

    const getRequisitionForm = async () => {
        // Fetch form if API provided
    };

    useEffect(() => {
        setFormSchema(_formSchema);
    }, [_formSchema]);

    useEffect(() => {
        if (_formSchema?.schema) return;
        getRequisitionForm();
    }, []);

    return (
        <>
            {formSchema?.schema &&
                <AlpacaForm
                    formSchema={formSchema}
                />
            }
        </>
    );
};

export default RequisitionForm;